var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.663574,
    width: 74.6726,
    height: 73.7776,
    rx: 16,
    fill: "#F1F6F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3291_29370",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 44,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8786 32.7823H59.3362V16H16.6636V57.7776H59.3362V42.4252H50.8786V51.9772H25.324V30.73L38.5366 21.8913H50.8786V32.7823Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3291_29370)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3291_29370)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.4072,
    cy: 19.958,
    r: 28.8398,
    fill: "#1782FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3291_29370)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.1677,
    cy: 23.5505,
    r: 26.8767,
    fill: "#50B7F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3291_29370)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.6143,
    cy: 60.0957,
    r: 22.5635,
    fill: "#DC45EE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3291_29370)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.1011,
    cy: 56.4556,
    r: 26.2037,
    fill: "url(#paint0_linear_3291_29370)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3291_29370",
    x: 5.56738,
    y: -28.8818,
    width: 97.6797,
    height: 97.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_3291_29370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3291_29370",
    x: -26.709,
    y: -23.3262,
    width: 93.7534,
    height: 93.7534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_3291_29370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3291_29370",
    x: -23.9492,
    y: 17.5322,
    width: 85.127,
    height: 85.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_3291_29370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3291_29370",
    x: 7.89746,
    y: 10.252,
    width: 92.4072,
    height: 92.4072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_3291_29370"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3291_29370",
    x1: 27.8975,
    y1: 34.6192,
    x2: 86.9594,
    y2: 46.4885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.506cadc0f3d39c0cea6da233a3be7bd4.svg";
export { ForwardRef as ReactComponent };